<div
  class="me-2"
  #notificationPopoverElement="ngbPopover"
  [ngbPopover]="popOver"
  popoverTitle="Notifications"
  popoverClass="notification-popover"
  [autoClose]="'outside'"
  (shown)="onShowNotification()"
  (hidden)="onHideNotification()">
  <div class="--notification-icon-container position-relative">
    <mat-icon [inline]="true" class="--notification-icon fs-16 w-100">notifications_none </mat-icon>
    @if (notification.unseen_count) {
      <div class="--notification-count d-flex justify-content-center">
        <span class="text-white fs-12" [ngClass]="{ 'fs-12': notification.unseen_count < 99, 'fs-10': notification.unseen_count > 99 }">{{
          notification.unseen_count > 99 ? "99+" : notification.unseen_count
        }}</span>
      </div>
    }
  </div>
</div>
<ng-template #popOver>
  <div class="notification-container" [ngClass]="{ 'show-loader': showSpinner, 'hide-loader': !showSpinner }">
    <div class="notification-header d-flex justify-content-between align-items-center">
      <div class="left__content">
        <button class="btn-sm-outlined-primary" matRipple (click)="onMarkAllAsRead()">Mark All As Read</button>
      </div>
      <div class="right__content">
        <select class="option-selection" [(ngModel)]="selectedCategory" (change)="getMagicBallNotification()">
          @for (item of notificationCategory; track $index) {
            <option [value]="item.value">{{ item.name }}</option>
          }
        </select>
      </div>
    </div>
    @for (item of notification.notifications; track $index) {
      <div class="notification-card d-flex" (click)="onClickNotification(item)" [ngClass]="{ unread: !item.read_at }">
        <div class="card-active d-flex justify-content-center align-items-center flex-column">
          <div class="active-dot"></div>
          @if (item.action_url) {
            <mat-icon [inline]="true" class="fs-14 ps-1 --text-blue" matTooltip="Link" [matTooltipPosition]="'below'">link</mat-icon>
          }
        </div>
        <div class="card-body">
          <h1 class="fs-14 text-dark m-0 p-0">{{ item?.title }}</h1>
          <p class="fs-12 --text-gray m-0 p-0">
            {{ item.content }}
          </p>
        </div>
        <div class="card-action mt-1 d-flex flex-column justify-content-center align-items-center" ngbDropdown>
          @if (item.sent_at) {
            <span class="fs-10" [matTooltip]="getSentTime(item.sent_at)" matTooltipPosition="above">{{ item.sent_at | timeAgo }}</span>
          }
          <mat-icon [inline]="true" class="fs-14 ps-2" matTooltip="Action" [matTooltipPosition]="'below'" (click)="onNotificationOption($event)" id="cardAction" ngbDropdownToggle>more_horiz</mat-icon>
          <div ngbDropdownMenu aria-labelledby="cardAction">
            <button ngbDropdownItem (click)="notificationMarkAsReadAndUnRead(item, $event)">{{ item.read_at ? "Mark as un-read" : "Mark as read" }}</button>
            <button ngbDropdownItem (click)="deleteNotification(item, $event)">Delete</button>
          </div>
        </div>
      </div>
    }
    <div class="notification-footer d-flex align-items-center justify-content-between">
      <div class="left__content">
        <span class="fw-bold text-dark"
          >Notifications : <span class="text-primary">{{ notification.notifications.length || 0 }}</span></span
        >
      </div>
      <div class="right__content">
        <mat-icon class="me-2" [inline]="false" (click)="onArrowLeft()">arrow_circle_left</mat-icon>
        <mat-icon class="" [inline]="false" (click)="onArrowRight()">arrow_circle_right</mat-icon>
      </div>
    </div>
    <div class="notification-loader">
      <div class="spinner-border text-primary" role="status">
        <!-- <span class="sr-only">Loading...</span> -->
      </div>
    </div>
  </div>
</ng-template>
